const findParentAndIndexOfNode = (tree, searchId, parent = null, index = 0) => {
  // If this tree is the ID we are searching for, return the parent and index
  // that was passed in.
  if (tree.id === searchId) {
    return {
      parent,
      index
    };
  }
  // Otherwise, search through its children
  let match = null;
  tree.children.some((childNode, childIndex) => {
    const result = findParentAndIndexOfNode(childNode, searchId, tree.id, childIndex);
    if (result) {
      match = result;
      return true;
    }
    return false;
  });
  return match;
};

export default findParentAndIndexOfNode;
